module.exports = __webpack_public_path__ + "img/ijr-caminhao1-300x205.b97ec61e.jpg";